const IMAGE_HOST = '//e.thsi.cn/image/';
const DEFAULT_SPAN = 1;
const DEFAULT_INDEX = 0;
const CATALOG_LEVEL_OFFSET = 1;
const MAX_HEADER_LEVEL = 6;
const ROW_INDEX = 1;
const COLUMN_INDEX = 2;
const ROWSPAN_INDEX = 3;
const COLSPAN_INDEX = 4;
const PAGE_INDEX = 0;
const REAL_POS_LEFT_INDEX = 0;
const REAL_POS_RIGHT_INDEX = 2;
const ALIGN_DELTA_DIVISOR = 30;
const CENTER_LEFT_MIN = 120;
const CENTER_DIFF_BASE = 16;
const RIGHT_MARGIN_MAX = 120;
const RIGHT_LEFT_MIN = 140;
const RIGHT_DIFF_MIN = 100;

function escapeHtml(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function getPosValue(item, index) {
  return Array.isArray(item.pos) ? Number(item.pos[index]) || DEFAULT_INDEX : DEFAULT_INDEX;
}

function getPageInfo(item, pageInfos) {
  const pageNum = getPosValue(item, PAGE_INDEX);
  if (pageNum === -1) {
    return null;
  }
  return pageInfos[pageNum - DEFAULT_SPAN] || null;
}

function getPageInfoWidth(pageInfo) {
  return Number(pageInfo.width) || DEFAULT_INDEX;
}

function getRealPosValue(item, index) {
  return Number(item.real_pos[index]) || DEFAULT_INDEX;
}

function getTextMargins(item, pageInfoWidth) {
  const leftMargin = Math.abs(getRealPosValue(item, REAL_POS_LEFT_INDEX));
  const rightMargin = Math.abs(pageInfoWidth - getRealPosValue(item, REAL_POS_RIGHT_INDEX));
  return {
    leftMargin,
    rightMargin,
  };
}

function shouldCenterText({ leftMargin, rightMargin }) {
  const deltaMargin = Math.min(leftMargin, rightMargin) / ALIGN_DELTA_DIVISOR;
  return leftMargin > CENTER_LEFT_MIN && Math.abs(leftMargin - rightMargin) < CENTER_DIFF_BASE + deltaMargin;
}

function shouldAlignRight({ leftMargin, rightMargin }) {
  return rightMargin < RIGHT_MARGIN_MAX && leftMargin > RIGHT_LEFT_MIN || leftMargin - rightMargin > RIGHT_DIFF_MIN;
}

function getRightAlignClass(isHeader) {
  return isHeader ? ' textcenter' : ' textright';
}

function getTextAlignClass(item, pageInfos = [], isHeader = false) {
  const pageInfo = getPageInfo(item, pageInfos);
  if (!pageInfo || !Array.isArray(item.real_pos)) {
    return '';
  }

  const pageInfoWidth = getPageInfoWidth(pageInfo);
  if (!pageInfoWidth) {
    return '';
  }

  const textMargins = getTextMargins(item, pageInfoWidth);
  if (shouldCenterText(textMargins)) {
    return ' textcenter';
  }
  if (shouldAlignRight(textMargins)) {
    return getRightAlignClass(isHeader);
  }
  return '';
}

function hasAncestorType(item, itemMap, type) {
  let parent = itemMap[item.parent];
  while (parent) {
    if (parent.type === type) {
      return true;
    }
    parent = itemMap[parent.parent];
  }
  return false;
}

function createItemMap(items) {
  return items.reduce((map, item) => {
    map[item.id] = item;
    return map;
  }, {});
}

function createCatalogMap(catalogs = []) {
  return catalogs.reduce((map, item) => {
    map[item.id] = Math.min(Number(item.level) + CATALOG_LEVEL_OFFSET, MAX_HEADER_LEVEL);
    return map;
  }, {});
}

function renderImage(item, pageInfos) {
  if (!item.text) {
    return '';
  }
  const textAlignClass = getTextAlignClass(item, pageInfos);
  const dataPage = getPosValue(item, PAGE_INDEX);
  const image = `<img id="hx_${item.id}" class="hx_pdf_img" data-page="${dataPage}" src="${IMAGE_HOST}${item.text}" alt="" />`;
  return `<div class="wrapper_img${textAlignClass}"><div class="img_div">${image}</div></div>`;
}

function renderHeader(item, level, pageInfos) {
  const textAlignClass = getTextAlignClass(item, pageInfos, true);
  return `<h${level} id="hx_${item.id}" class="hx_pdf_header${textAlignClass}" data-page="${getPosValue(item, PAGE_INDEX)}">${escapeHtml(item.text)}</h${level}>`;
}

function renderParagraph(item, pageInfos) {
  const textAlignClass = getTextAlignClass(item, pageInfos);
  return `<div id="hx_${item.id}" class="hx_pdf_p${textAlignClass}" data-page="${getPosValue(item, PAGE_INDEX)}">${escapeHtml(item.text)}</div>`;
}

function renderCellContent(item) {
  if (item.type === 'image') {
    return renderImage(item);
  }
  if (item.type === 'paragraph') {
    return `<span id="hx_${item.id}">${escapeHtml(item.text)}</span>`;
  }
  return '';
}

function sortByRowAndColumn(prev, next) {
  const rowDelta = getPosValue(prev, ROW_INDEX) - getPosValue(next, ROW_INDEX);
  if (rowDelta) {
    return rowDelta;
  }
  return getPosValue(prev, COLUMN_INDEX) - getPosValue(next, COLUMN_INDEX);
}

function groupRows(cells) {
  return cells.reduce((rows, cell) => {
    const row = getPosValue(cell, ROW_INDEX);
    if (!rows[row]) {
      rows[row] = [];
    }
    rows[row].push(cell);
    return rows;
  }, []).filter(Boolean);
}

function renderCell(cell, items, itemMap) {
  const rowspan = getPosValue(cell, ROWSPAN_INDEX) || DEFAULT_SPAN;
  const colspan = getPosValue(cell, COLSPAN_INDEX) || DEFAULT_SPAN;
  const content = items
    .filter(item => item.parent === cell.id && !hasAncestorType(item, itemMap, 'image'))
    .map(item => renderCellContent(item))
    .join('');

  return `<td rowspan="${rowspan}" colspan="${colspan}">${content}</td>`;
}

function renderTable(tableItem, items, itemMap) {
  const cells = items
    .filter(item => item.type === 'cell' && item.parent === tableItem.id)
    .sort(sortByRowAndColumn);

  if (!cells.length) {
    return '';
  }

  const rows = groupRows(cells);
  const body = rows
    .map(row => `<tr>${row.map(cell => renderCell(cell, items, itemMap)).join('')}</tr>`)
    .join('');

  return `<div class="wrapper_table"><table id="hx_${tableItem.id}" class="hx_pdf_tb"><tbody>${body}</tbody></table></div>`;
}

function shouldRenderRootItem(item, itemMap) {
  return !hasAncestorType(item, itemMap, 'table') && !hasAncestorType(item, itemMap, 'image') && item.type !== 'cell';
}

function renderItem(item, items, itemMap, catalogMap, pageInfos) {
  if (catalogMap[item.id]) {
    return renderHeader(item, catalogMap[item.id], pageInfos);
  }
  if (item.type === 'image') {
    return renderImage(item, pageInfos);
  }
  if (item.type === 'paragraph') {
    return renderParagraph(item, pageInfos);
  }
  if (item.type === 'table') {
    return renderTable(item, items, itemMap);
  }
  return '';
}

export function renderPdfAna(pdfAna = {}) {
  const items = Array.isArray(pdfAna.items) ? pdfAna.items : [];
  if (!items.length) {
    return '';
  }

  const itemMap = createItemMap(items);
  const catalogMap = createCatalogMap(pdfAna.catalogs);
  const pageInfos = Array.isArray(pdfAna.page_infos) ? pdfAna.page_infos : [];
  return items
    .filter(item => shouldRenderRootItem(item, itemMap))
    .map(item => renderItem(item, items, itemMap, catalogMap, pageInfos))
    .join('');
}
